jQuery(document).ready(function ($) {
	// Cache the quick links block element
	var $quickLinks = $(".jh-quick-links-block");

	// Exit early if quick links block doesn't exist on this page
	if (!$quickLinks.length) {
		return;
	}

	// Store the initial offset from the top of the page
	var initialOffset = $quickLinks.offset().top;

	// Updates the position of the quick links block based on scroll
	function updateQuickLinksPosition() {
		// Add 'is-fixed' class if scrolled past initial offset, else remove it
		if ($(window).scrollTop() > initialOffset) {
			$quickLinks.addClass("is-fixed");
		} else {
			$quickLinks.removeClass("is-fixed");
		}
	}

	// Listen for scroll and resize events to update position
	$(window).on("scroll resize", updateQuickLinksPosition);
	// Initial position update on page load
	updateQuickLinksPosition();

	// Re-cache elements for toggling open/close
	var $quickLinks = $(".jh-quick-links-block");
	var $header = $quickLinks.find(".jh-quick-links-block__header");
	var $content = $quickLinks.find(".jh-quick-links-block__content");

	// Closes the quick links dropdown
	function closeQuickLinks() {
		$quickLinks.removeClass("open");
		$header.removeClass("open");
	}

	// Toggle open/close when header is clicked
	$header.on("click", function (e) {
		e.stopPropagation();
		$quickLinks.toggleClass("open");
		$header.toggleClass("open");
	});

	// Close quick links when clicking outside the block
	$(document).on("click", function (e) {
		if ($quickLinks.hasClass("open")) {
			if (!$(e.target).closest(".jh-quick-links-block").length) {
				closeQuickLinks();
			}
		}
	});

	// Optional: close quick links when ESC key is pressed
	$(document).on("keydown", function (e) {
		if (e.key === "Escape") {
			closeQuickLinks();
		}
	});
});
